import { Box, Flex } from "@chakra-ui/react";
import React from "react";
import { HCardWithImageProps } from "./horizontal-cards.types";

export const HCardWithImage: React.FC<HCardWithImageProps> = ({
  imageHoverTopLeft,
  imageHoverBottomLeft,
  children,
  imageUrl = "/images/opportunity-default-image-3.png",
  ...rest
}) => {
  return (
    <Flex
      className={"mb-4 rounded-md flex-col sm:flex-row"}
      boxShadow={2}
      {...rest}
    >
      <Box
        className={"w-full h-40 relative sm:h-auto sm:max-w-[236px]"}
        backgroundSize="cover"
        backgroundPosition="center"
        backgroundImage={`linear-gradient(26.92deg, rgba(0, 0, 0, 0.35) -19.39%, rgba(0, 0, 0, 0) 78.92%), url('${imageUrl}')`}
      >
        <Box position="absolute" top={3} left={3} w="fit-content">
          {imageHoverTopLeft}
        </Box>
        <Box position="absolute" bottom={3} left={3} w="fit-content">
          {imageHoverBottomLeft}
        </Box>
      </Box>
      <Box p={5} w="100%">
        {children}
      </Box>
    </Flex>
  );
};
